import { IFutureOrder, ISupplierExposure } from '../../../../sp-types/FutureOrderType';
import { MonthYearValue, sumOfMonthYearValue } from '../../../../utils/MonthYear/MonthYearValue';
import { futureOrderProductDistributionTypes } from '../../../../utils/MonthYear/distributeValueThroughDates/distributeValueThroughDates';
import { isEqualMonthYear, MonthYear } from '../../../../utils/MonthYear/monthYear';
import { sortByDate } from '../../../BalanceFlow/balanceUtils';

export const getDeliveryDates = (
  quantity: number,
  deliveryDates: MonthYear[],
  deliveryType: string,
  oldValues: MonthYearValue[],
): MonthYearValue[] => {
  const distributionMethod = futureOrderProductDistributionTypes.find((item) => item.name === deliveryType);
  if (distributionMethod) {
    return deliveryDates.length > 1
      ? distributionMethod.distributionMethod(quantity, deliveryDates[0], deliveryDates[1])
      : distributionMethod.distributionMethod(quantity, deliveryDates[0]);
  }
  return oldValues;
};

export const isSupplierExposuresAreFromTheSameProduct = (
  arr1: ISupplierExposure[],
  arr2: ISupplierExposure[],
): boolean => {
  if (arr1.length !== arr2.length) return false;

  // Sort arrays by materialId and weightInProduct
  const sortedArr1 = [...arr1].sort(
    (a, b) => a.formulaId.localeCompare(b.formulaId) || a.weightInProduct - b.weightInProduct,
  );
  const sortedArr2 = [...arr2].sort(
    (a, b) => a.formulaId.localeCompare(b.formulaId) || a.weightInProduct - b.weightInProduct,
  );

  // Compare each element based on materialId and weightInProduct
  return sortedArr1.every(
    (item, index) =>
      item.formulaId === sortedArr2[index].formulaId && item.weightInProduct === sortedArr2[index].weightInProduct,
  );
};
export const isFormFilledCorrectly = ({
  orderId,
  productId,
  orderDetails,
}: IFutureOrder): { state: boolean; massage: string } => {
  const { deliveryDates, deliveryType, productDeliveryCalendar, quantity, pricePerUnit } = orderDetails;

  if (!(orderId && productId && deliveryDates && deliveryType && quantity && pricePerUnit && productDeliveryCalendar)) {
    return { state: false, massage: 'Missing details' };
  }
  if (productDeliveryCalendar.length === 0) {
    return { state: false, massage: 'Missing details' };
  }

  const sortedProductCal = productDeliveryCalendar.sort(sortByDate);
  const sortedDeliveries = deliveryDates.sort((a, b) => sortByDate({ date: a, value: 0 }, { date: b, value: 0 }));
  if (
    quantity !== sumOfMonthYearValue(productDeliveryCalendar) ||
    !isEqualMonthYear(sortedProductCal[0].date, sortedDeliveries[0]) ||
    !isEqualMonthYear(sortedProductCal[sortedProductCal.length - 1].date, sortedDeliveries[sortedDeliveries.length - 1])
  ) {
    return { state: false, massage: 'Missing details update chart' };
  }

  return { state: true, massage: 'Success' };
};
